import apiClient from './apiClient'

/** @enum {string} */
export const SerializationContexts = Object.freeze({
  SECTOR: 'sector',
  SECTION: 'section'
})

export const getAllStudentPathways = (user, params) => apiClient.get(user, 'api/student-pathways', params)
